<script>
import DropdownNavigation from './DropdownNavigation.vue';

export default {
  name: 'TheNavigation',
  components: {
    DropdownNavigation,
  },
  data() {
    return {};
  },
  methods: {
    changeLanguage(val) {
      localStorage.setItem('language', val);
      this.$i18n.locale = val;
    },
  },
  computed: {},
};
</script>

<template>
  <nav class="nav">
    <svg
      @click="$emit('hamClicked')"
      class="ham-icon"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="hsl(var(--clr-primary-100))"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <line x1="3" y1="12" x2="21" y2="12"></line>
      <line x1="3" y1="6" x2="21" y2="6"></line>
      <line x1="3" y1="18" x2="21" y2="18"></line>
    </svg>
    <h1 class="logo">Rizes House</h1>
    <ul class="nav-links">
      <li class="nav-link">
        <router-link to="/">{{ $t('navigation.homePage') }}</router-link>
      </li>
      <li class="nav-link">
        <router-link to="/aboutus">{{
          $t('navigation.aboutPage')
        }}</router-link>
      </li>
      <dropdown-navigation></dropdown-navigation>
      <li class="nav-link">
        <router-link to="/outside">{{ $t('navigation.extPage') }}</router-link>
      </li>
      <li class="nav-link">
        <router-link to="/contact">{{
          $t('navigation.contactPage')
        }}</router-link>
      </li>
    </ul>
    <ul class="nav-lang">
      <li class="lang-link" @click="changeLanguage('en')">
        <svg
          width="22"
          height="15"
          viewBox="0 0 22 15"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_1221_108)">
            <path d="M22.0004 0H0V14.667H22.0004V0Z" fill="#000066" />
            <path
              d="M0 0V1.63982L19.5408 14.667H22.0004V13.0272L2.45965 4.88899e-05H0L0 0ZM22.0004 0V1.63977L2.45965 14.667H0V13.0272L19.5408 0H22.0004Z"
              fill="white"
            />
            <path
              d="M9.16685 0V14.667H12.8336V0H9.16685ZM0 4.88899V9.77797H22.0004V4.88899H0Z"
              fill="white"
            />
            <path
              d="M0 5.86678V8.80018H22.0004V5.86678H0ZM9.9002 0V14.667H12.1002V0H9.9002Z"
              fill="#CC0000"
            />
            <path
              d="M0 14.667L7.33348 9.77797H8.97325L1.63977 14.667H0H0ZM0 0L7.33348 4.88899H5.69371L0 1.09323V0L0 0ZM13.0272 4.88899L20.3607 0H22.0004L14.667 4.88899H13.0272ZM22.0004 14.667L14.667 9.77797H16.3067L22.0004 13.5738V14.667Z"
              fill="#CC0000"
            />
          </g>
          <defs>
            <clipPath id="clip0_1221_108">
              <rect width="22" height="14.6667" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </li>
      <li class="lang-link" @click="changeLanguage('gr')">
        <svg
          width="24"
          height="16"
          viewBox="0 0 24 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M0 0H24V16H0V0Z" fill="#0D5EAF" />
          <path
            d="M0 13.3333H24M4.44444 0V9.77778V0ZM0 4.44444H8.88889H0ZM8.88889 2.66667H24H8.88889ZM8.88889 6.22222H24H8.88889ZM0 9.77778H24H0Z"
            stroke="white"
            stroke-width="2"
          />
        </svg>
      </li>
    </ul>
  </nav>
</template>

<style scoped lang="scss">
.nav {
  // max-width: 1440px;
  height: var(--size-9-8);
  margin: 0 auto;
  padding: 0px var(--size-9-7);

  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  background-color: hsl(var(--clr-primary-700));
}

.ham-icon {
  display: none;
}

.logo {
  font-size: var(--fs-10-8);
}

.nav-links {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.nav-link {
  height: 100%;
  padding: 0px var(--size-4-3);

  color: hsl(var(--clr-primary-100));
  background-color: hsl(var(--clr-primary-700));
  transition: all 0.3s ease-in-out;

  a {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    font-family: var(--ff-serif);
    font-style: normal;
    font-weight: 400;
    font-size: var(--fs-4-3);
    line-height: 22px;
    letter-spacing: 1px;
    text-transform: uppercase;

    color: hsl(var(--clr-primary-100));
  }
}

.nav-link:hover,
.nav__link:active,
.nav__link:focus {
  background-color: hsl(var(--clr-primary-500));
}

.nav-lang {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.lang-link {
  cursor: pointer;
}

@media screen and (max-width: 902px) {
  .nav-links {
    display: none;
  }

  .ham-icon {
    display: block;
    cursor: pointer;
  }
}
</style>
